import { type RefObject, useEffect } from 'react';

import { useLocation } from './router';

/** Scroll the given container back to the top whenever the route path changes. */
export function useScrollToTopOnNavigate(
  ref: RefObject<HTMLElement | null>,
): void {
  const { pathname } = useLocation();
  useEffect(() => {
    ref.current?.scroll({ top: 0 });
  }, [ref, pathname]);
}

/**
 * Return the path segment at `segmentIndex` (default 3, e.g. the page name in
 * `/team/:id/<page>`), used to highlight the active menu entry.
 */
export function useSelectedKeyFromPath(segmentIndex = 3): string {
  const { pathname } = useLocation();
  return pathname.split('/')[segmentIndex] ?? '';
}
